import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const TiposProductoQuejaTable = ({
  setIdTipoProducto,
  setOpenModal,
  tiposproducto
}) => {
  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'descripcion',
      header: 'Tipo Producto',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idtipoproducto',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idtipoproducto } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdTipoProducto(idtipoproducto);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                  variant="falcon-default"
                  size="sm"
                  title="Eliminar"
                  onClick={() => {
                    setIdMunicipioToDelete(idmunicipio);
                    setOpenConfirm(true);
                  }}
                >
                  <FontAwesomeIcon icon="trash-alt" />
                </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={tiposproducto}
        columns={columns}
        title="Tipos de Producto"
        addAction={() => {
          setIdTipoProducto(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
TiposProductoQuejaTable.propTypes = {
  tiposproducto: PropTypes.array.isRequired,
  setIdTipoProducto: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};

export default TiposProductoQuejaTable;
